module.exports = __webpack_public_path__ + "img/figure_1.bb39a39e.svg";